<h1 mat-dialog-title>Convert</h1>
<div mat-dialog-content style="height: calc(100% - 96px);">
  <div *ngIf="supportGLM">
    <label id="source-file-type-label">Source Label Type</label>
    <mat-radio-group aria-label="Source File Type" id="sourceType" class="radio-group">
      <mat-radio-button value="LPS" name="lpsRadio" class="radio-button" ngDefaultControl
        [(ngModel)]="conversionDetails.migrationType">LPS</mat-radio-button>
      <mat-radio-button value="RTF" name="glmRadio" class="radio-button" ngDefaultControl
        [(ngModel)]="conversionDetails.migrationType">GLM</mat-radio-button>
    </mat-radio-group>
  </div>
  <div *ngIf="inputData.sourceType =='RTF'">
    <label id="target-labeling-solution-label">Target Labeling Solution</label>
    <mat-radio-group aria-label="Select an option" class="radio-group">
      <mat-radio-button value="ser" name="serRadio" class="radio-button" ngDefaultControl
        [(ngModel)]="conversionDetails.output">Spectrum
        (.ser)</mat-radio-button>
      <mat-radio-button value="nlbl" name="nlblRadio" class="radio-button" ngDefaultControl
        [(ngModel)]="conversionDetails.output">NiceLabel
        (.nlbl)</mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="inputData.sourceType =='LPS'" class="wrapper">
    <div id="targetSettings">
      
      <mat-form-field style="width: 100%">
        <mat-label>Target Version</mat-label>
        <mat-select [(ngModel)]="conversionDetails.targetVersion">
          <mat-option *ngFor="let version of spectrumVersions" [value]="version.value">{{version.label}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-button-toggle-group
        name="conversionDialogMenu"
        id="conversionDialogMenu"
        hideSingleSelectionIndicator="true"
        vertical="true"
        value="conversion">
        <mat-button-toggle value="conversion" (click)="showConversionDetails()">
          <mat-icon>computer</mat-icon>
          <span>&nbsp;&nbsp;Conversion Details</span>
        </mat-button-toggle>
        <mat-button-toggle value="advanced" (click)="showAdvancedOptions()">
          <mat-icon>description</mat-icon>
          <span>&nbsp;&nbsp;Advanced Options</span>
        </mat-button-toggle>
      </mat-button-toggle-group>

    </div>
    <div *ngIf="displayConversionDetails" id="conversionDetails" class="panelWrapper">
      <div id="conversionDetailsTitle" class="panelTitle">Conversion Details</div>
      <div id="conversionDetailsPanel">
        <conversion-details-panel (validationEvent)="conversionDetailsValidationHandler($event)" [(conversionDetails)]="conversionDetails"></conversion-details-panel>
      </div>
    </div>
    <div *ngIf="displayAdvancedOptions" id="advancedOptions" class="panelWrapper">
      <div id="advanceOptionsTitle" class="panelTitle">Advanced Options</div>
      <div id="advancedOptionsPanel">
        <advanced-options-panel (validationEvent)="advancedOptionsValidationHandler($event)" [(conversionDetails)]="conversionDetails"></advanced-options-panel>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close (click)="onConvert()" [disabled]="convertDisabled()">Convert</button>
  <button mat-raised-button mat-dialog-close (click)="onCancel()">Cancel</button>
</div>